import React from "react";
import { connect } from "react-redux";
import AddForm from "./AddForm";
import ListForm from "./ListForm";

class Index extends React.Component<any, any> {
  render() {
    const { orderId, viewOnly } = this.props;

    return (
      <div className="row" style={{ marginTop: "10px" }}>
        <div className="col-xs-12">
          <span className="bold"> Ordered Item(s) </span>
        </div>
        <div className="col-xs-12">
          <AddForm orderId={orderId} viewOnly={viewOnly} />
        </div>
        <div className="col-xs-12 scrolled-row">
          <ListForm orderId={orderId} viewOnly={viewOnly} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (_state: any, _props: any) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
